<template>
  <v-card :class="margin">
    <alert-header-panel :panel-type="panelType"
                        :panel-colour="panelColour"
                        :checkbox-value="templateCheckbox"
                        @set-checkbox="showAllTemplates"
                        :checkbox-id="templateCheckboxId"/>
    <v-list id="alert-template-list" dense class="py-0">
      <v-progress-linear v-if="templatesLoading" height="2" indeterminate color="accent" class="my-0"></v-progress-linear>
      <alert-template-item v-for="(template, key) in templateItems"
                           :key="key"
                           v-if="template.submitted && !template.isDeleted"
                           :template="template"
                           :template-key="key"
                           :panel-colour="panelColour"/>
      <v-divider/>
      <v-btn id="new-template-item" aria-label="new-template-item" @click="clickNewTemplate" :disabled="checkSubmitted" block flat class="my-0 text-capitalize ignore-none">
        <span>{{$t('admin.alerts.new.email_templates.new')}}</span>
        <v-spacer/>
        <v-icon>add</v-icon>
      </v-btn>
    </v-list>

    <v-expansion-panel>
      <v-expansion-panel-content :style="panelColour" lazy tabindex="0" id="template-view-placeholders" aria-label="template-view-placeholders">
        <div slot="header">
          <span>{{$t('admin.alerts.new.placeholders.title')}}</span>
        </div>
        <v-list dense class="py-0">
          <placeholder-group v-for="(pg, key) in groupedPlaceholders" :key="key"
            :placeholder-group="pg" :placeholder-key="key"/>
        </v-list>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-card>
</template>
<script>
  import PlaceholderGroup from './PlaceholderGroup'
  import AlertTemplateItem from './AlertTemplateItem'
  import AlertHeaderPanel from './AlertHeaderPanel'
  import { SHOW_ALL_TEMPLATES, CREATE_NEW_EMAIL_TEMPLATE_ITEM } from '../../../store/mutation-types'

  export default {
    name: 'alert-templates',
    components: {AlertHeaderPanel, AlertTemplateItem, PlaceholderGroup},
    data () {
      return {
        panelType: {
          title: 'admin.alerts.new.email_templates.title',
          info: 'admin.alerts.new.email_templates.info'
        }
      }
    },
    props: {
      margin: {},
      panelColour: {}
    },
    methods: {
      showAllTemplates (value) {
        this.$store.commit(SHOW_ALL_TEMPLATES, value)
      },
      clickNewTemplate () {
        if (!this.checkSubmitted) {
          this.$store.commit(CREATE_NEW_EMAIL_TEMPLATE_ITEM)
        }
      }
    },
    computed: {
      placeholders () {
        return this.$store.state.admin.placeholders
      },
      groupedPlaceholders () {
        return this.placeholders.reduce((h, {id, placeholderIdentifier, placeholderDefault, group, clipped}) => {
          return Object.assign(h, {[group]: (h[group] || []).concat({id, placeholderIdentifier, placeholderDefault, group, clipped})})
        }, {})
      },
      templateCheckbox () {
        return this.templateItems ? this.templateItems.filter(el => el.visible).length === this.templateItems.length : false
      },
      templateItems () {
        return this.$store.state.admin.newSingleAlert.emailTemplates
      },
      checkSubmitted () {
        return this.templateItems
          ? this.templateItems.filter(el => !el.submitted).length > 0
          : false
      },
      templateCheckboxId () {
        return 'show-all-templates'
      },
      templatesLoading () {
        return this.$store.state.admin.templatesLoading
      }
    }
  }
</script>

<style>
  .expansion-panel__header {
    padding: 12px 16px
  }
  .list__group__items {
    list-style: none;
  }
  .list__group__header--sub-group .list__group__header__prepend-icon {
    padding: 0px 0px 0px 13px;
    margin-right: 0px;
    min-width: 20px;
  }
  .list__group__items--no-action .list__tile {
    padding-left: 15px;
  }
  .list__tile__action {
    min-width: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/alert/AlertTemplates.vue